import getConfig from 'next/config'

let logger
if (!process.browser) {
  // tslint:disable-next-line:no-var-requires
  logger = require('@goat/server-common').logger
}

export const isomorphicLog = (...args) => {
  if (typeof window === 'undefined') {
    logger.info(...args)
    return
  }
  const { publicRuntimeConfig } = getConfig()
  if (publicRuntimeConfig.releaseEnv !== 'production') {
    // tslint:disable-next-line:no-console
    console.log(...args)
  }
}
